import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { maskCpfOrCnpj } from '../../../../../services/masks';
import { translatePropertyStatus } from '../../../util';

const CLAIM_UPDATES_ACCENT_COLOR = '#59249B';

const InfoContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-left: 4px solid ${CLAIM_UPDATES_ACCENT_COLOR};
  padding: 0 0 0 12px;
  border-radius: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 0.7fr) minmax(0, 1.6fr);
  gap: 16px 24px;
  align-items: flex-start;
  color: #2f3441;
  margin: 0 0 22px;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;

  > strong {
    color: #707682;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.15;
  }

  > span {
    color: #2f3441;
    font-size: 14px;
    line-height: 1.35;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
`;

const InfoSecondary = styled.span`
  color: #707682 !important;
  font-size: 12px !important;
  line-height: 1.25 !important;
`;

type ClaimInfoHeaderProps = {
  claim: any;
};

const ClaimInfoHeader = ({ claim }: ClaimInfoHeaderProps) => {
  const {
    propertyStreet,
    propertyNumber,
    propertyComplement,
    propertyDistrict,
    propertyCity,
    propertyState,
    tenantName,
    tenantDocument,
    estateName,
    createdAt,
    propertyStatus
  } = claim || {};

  const fullAddress = `${propertyStreet || ''}, ${propertyNumber || ''}${
    propertyComplement ? ` ${propertyComplement}` : ''
  } - ${propertyDistrict || ''} - ${propertyCity || ''} - ${propertyState || ''}`;

  return (
    <InfoContainer>
      <InfoItem>
        <strong>Inquilino</strong>
        <span>{tenantName}</span>
        {tenantDocument && (
          <InfoSecondary>{maskCpfOrCnpj(tenantDocument)}</InfoSecondary>
        )}
      </InfoItem>
      <InfoItem>
        <strong>Imobiliária</strong>
        <span>{estateName}</span>
      </InfoItem>
      <InfoItem>
        <strong>Data de abertura</strong>
        <span>{createdAt ? moment(createdAt).format('DD/MM/YYYY') : '-'}</span>
      </InfoItem>
      <InfoItem>
        <strong>Imóvel</strong>
        <span>{fullAddress}</span>
        {propertyStatus && (
          <InfoSecondary>
            {translatePropertyStatus(propertyStatus)}
          </InfoSecondary>
        )}
      </InfoItem>
    </InfoContainer>
  );
};

export default ClaimInfoHeader;
